var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.627,
    height: 37.583,
    viewBox: "0 0 33.627 37.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11455",
    "data-name": "Group 11455",
    transform: "translate(-166.371 -2927.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_758",
    "data-name": "Ellipse 758",
    transform: "translate(173.838 2927.933)",
    fill: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.5,
    rx: 9,
    ry: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.5,
    rx: 8.5,
    ry: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29606",
    "data-name": "Path 29606",
    d: "M134.941,2505.539s.36-16.457,15.758-16.566,16.871,16.566,16.871,16.566",
    transform: "translate(31.93 459.933)",
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4706",
    "data-name": "Line 4706",
    x2: 12.837,
    transform: "translate(176.419 2959.314)",
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29608",
    "data-name": "Path 29608",
    d: "M0,12.987V.385",
    transform: "translate(182.838 2952.314)",
    fill: "none",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/AddPerson.29cc5a6a977d0974a331a4cef1ddcc45.svg";
export { ForwardRef as ReactComponent };